import { useMemo } from 'react';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { useIframeCommunication } from 'hooks/useIframeCommunication';
import { apiEducationNext } from 'microfrontends/config/api';
import { buildThemeParams } from 'microfrontends/config/theme';

('use client');

interface EducationShowCaseProps {
  userId: string;
}

const EducationShowcaseNextJS = ({ userId }: EducationShowCaseProps) => {
  const theme = useThemeContext();

  const themeParams = useMemo(() => buildThemeParams(theme), [theme]);

  const getOrganizationUuid = () => {
    try {
      const orgUuid = localStorage.getItem('x-organization-uuid');
      if (!orgUuid) {
        console.warn('Organization UUID not found in localStorage');
        return '';
      }
      return orgUuid;
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };

  const baseUrl = useMemo(() => {
    const orgUuid = getOrganizationUuid();
    const url = new URL(`${apiEducationNext}/education-platform/education/journey`);

    // Adiciona o userId como parte do path
    url.pathname = `${url.pathname}/${userId}`;

    // Adiciona os parâmetros de query
    url.searchParams.append('organization_uuid', orgUuid);

    return url.toString();
  }, [userId]);

  const iframeUrl = useMemo(() => {
    const url = new URL(baseUrl);
    // Adiciona os parâmetros de tema
    const themeParamsObj = new URLSearchParams(themeParams);
    themeParamsObj.forEach((value, key) => {
      url.searchParams.append(key, value);
    });

    return url.toString();
  }, [baseUrl, themeParams]);

  const { iframeRef } = useIframeCommunication(iframeUrl);

  console.log('URL completa do iframe:', iframeUrl);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '85vh' }}>
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        style={{ flex: 1, border: 'none' }}
        width="100%"
        title="Showcase - Education Platform"
        allowFullScreen
        allow="autoplay; fullscreen; picture-in-picture"
      />
    </div>
  );
};

export default EducationShowcaseNextJS;
